import styled from 'styled-components'

export const StyledVolumesJATOAcademyPopUp = styled.div``
